import React, { useState } from 'react';
import styles from './Navbar.module.scss';

interface NavbarProps {
  onMenuClick?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onMenuClick }) => {
  const [search, setSearch] = useState('');

  


  return (
    <nav className={styles.navbar}>

      <div className={styles.navLogo}>
        <img src={require('../../assets/logo.png')} alt="lendsqr" />
      </div>

      <div className={styles.navMain}>

        <button className={styles.hamburger} onClick={onMenuClick}>
          <span />
          <span />
          <span />
        </button>

        <div className={styles.searchBar}>
          <input
            type="text"
            placeholder="Search for anything"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button className={styles.searchBtn}>
            <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="white" strokeWidth={2.5}>
              <circle cx="11" cy="11" r="8"/>
              <path strokeLinecap="round" d="M21 21l-4.35-4.35"/>
            </svg>
          </button>
        </div>

        <div className={styles.navRight}>

          <span className={styles.docsLink}>Docs</span>

          <button className={styles.notifBtn}>
            <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="#213F7D" strokeWidth={1.8}>
              <path strokeLinecap="round" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
            </svg>
            <span className={styles.notifDot} />
          </button>

          <div className={styles.userArea}>
            <div className={styles.avatar}>
              <img
                src="https://randomuser.me/api/portraits/men/32.jpg"
                alt="avatar"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
            </div>
            <span className={styles.userName}>
              Adedeji
              <svg width="12" height="12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <polyline points="6 9 12 15 18 9"/>
              </svg>
            </span>
          </div>

        </div>
      </div>
    </nav>
  );
};

export default Navbar;